import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';

import { BrowserSupportGate, WalletProvider } from '~/wallet';
import { EmbedWalletRoute } from '~/routes/EmbedWallet';
import { Login } from '~/routes/Login';
import { Register } from '~/routes/Register';
import { RootRedirect } from '~/routes/RootRedirect';
import { Account } from '~/routes/Account';
import { Applications, ApplicationDetail } from '~/routes/Applications';
import { Delegations } from '~/routes/Delegations';
import { Settings } from '~/routes/Settings';
import { NotSupported } from '~/routes/NotSupported';
import { getRuntimeConfig } from '~/config';

const router = createBrowserRouter([
  {
    element: (
      <BrowserSupportGate>
        <Outlet />
      </BrowserSupportGate>
    ),
    children: [
      { path: '/embed/wallet', element: <EmbedWalletRoute /> },
      { path: '/', element: <RootRedirect /> },
      { path: '/login', element: <Login /> },
      { path: '/register', element: <Register /> },
      { path: '/account', element: <Account /> },
      { path: '/applications', element: <Applications /> },
      { path: '/applications/:appId', element: <ApplicationDetail /> },
      { path: '/delegations', element: <Delegations /> },
      { path: '/settings', element: <Settings /> },
      { path: '/not-supported', element: <NotSupported /> },
      { path: '*', element: <RootRedirect /> },
    ],
  },
]);

export const getRoutes = () => router.routes;
export const AppRouter = () => (
  <WalletProvider apiBaseUrl={getRuntimeConfig().walletApiBaseUrl}>
    <RouterProvider router={router} />
  </WalletProvider>
);
